// jquery - https://jquery.com
// import * as jquery from 'jquery';
// window.$ = jquery;
// window.jQuery = jquery;

// slick carousel - https://kenwheeler.github.io/slick/
// import * as slick from 'slick-carousel';
// window.slick = slick;

import {ShopifyFrontendHelperAugmented} from "../components/cart-section/js/utils";
window.shopifyFrontendHelper = new ShopifyFrontendHelperAugmented();
